import script from "./DeductionsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DeductionsComponent.vue?vue&type=script&setup=true&lang=js"

import "./DeductionsComponent.vue?vue&type=style&index=0&id=10f00690&lang=scss&scoped=true"
import "./DeductionsComponent.vue?vue&type=style&index=1&id=10f00690&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f00690"]])

export default __exports__